import storage from 'good-storage';

const state = {
    lgtype:'',
    userId:'',
    token:'',
    type:'',
    imageUrl:'',
    nickname:'',
    realName:'',
    organization:'',
    memberStart:'',
    memberEnd:''
}

const mutations = {

   MuserSet(state,userDat){
        for(let key in state){
             if(key == 'userId'){
                state[key] = userDat.id;
             }else if(key == 'token' || key == 'organization' || key == 'lgtype'){
                state[key] = userDat[key];
             }else if(userDat.lgtype != 'ip'){
                state[key] = userDat.userInfo[key];
                if(key == 'memberEnd' || key == 'memberStart'){
                   if(userDat.userInfo[key]){
                      state[key] = userDat.userInfo[key].substr(0,10);
                   }
                }else{
                   state[key] = userDat.userInfo[key];
                }

             }
        }
   },

   MuserClean(state){
     for(let key in state){
        state[key] = '';
     }
   }

}

const actions = {

    AuserSet({commit},userDat){
        commit('MuserSet',userDat)
        storage.set('userInfo',{
             token:userDat.token,
             userId:userDat.id,
             imageUrl:userDat.userInfo.imageUrl,
             nickname:userDat.userInfo.nickname,
             organization:userDat.organization,
             memberEnd:userDat.userInfo.memberEnd,

        });
    },

    AuserClean({commit}){
        commit('MuserClean')
    }
}

export default {
    namespaced:true,
    state,
    mutations,
    actions
}
